import React, { Component, Fragment } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import {hit} from '../../metrics';
import CaseFooterNew from '../CaseFooterNew';
import HelmetSite from '../HelmetSite';
import './style.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "../../../../node_modules/swiper/swiper-bundle.min.css";

class annabels extends Component{
  swiperRef = React.createRef();
  swiperRef2 = React.createRef();
  state = {
		preview: true,
		play: false,
		mobile: window.innerWidth <= 1000
	};

	resize = () => this.setState({mobile: window.innerWidth <= 1000})

	componentDidMount(){
    var video = document.getElementById("video");
    $(".videoBlock__btn").click(function () {
      $(".videoBlock__btn").toggleClass("videoBlock__btn_hidden");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
		if(this.props.pathname == '/projects/annabels/'){
			this.setState({preview: false});
			this.props.setProjectName('annabels');
			$('body').addClass('case-expanded hash-annabels');
			$(window).scrollTop($('#case-annabels').offset().top);
			this.props.changeCase(null);
		}
		else{
			this.setState({preview: true});
			$('body').removeClass('hash-annabels');
    }
    window.scrollTo(0, 0);
    hit(window.location.pathname);

    setTimeout(() => {
			$('body').addClass('fadepage');
    }, 100);
	}

	componentDidUpdate(){
		if(this.props.pathname == '/projects/'){
			$('body').removeClass('case-expanded hash-annabels');
		}
  }

  componentWillUnmount() {
    $('body').removeClass('fadepage');
  }
  
	render(){
		return(
		<div className='case'>
			<div className="case-content" id="case-annabels">
        <div className="screen">
          <div className="topScreen">
            <div className="topScreen__bg" style={{backgroundImage: `url('/cases/img/annabels/bg-top.webp')`}} />
            <div className="topScreen__logo"><img src="/cases/img/annabels/logo.svg" alt="" /></div>
          </div>
          <div className="aboutProject">
            <div className="content">
              <div className="aboutProject__wrap">
                <div className="aboutProject__left">
                  <div className="aboutProject__title title">Клубный дом “Annabel’s”</div>
                  <div className="aboutProject__desc">
                    <div>
                      <div>Клиент</div>
                      <div>Palladio Group</div>
                    </div>
                    <div>
                      <div>Виды&nbsp;работ</div>
                      <div>
                        <div className="tabs">
                          <div>Сайт</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="aboutProject__text text">
                  Дизайн сайта передаёт эстетику клубного дома через тонкую визуальную композицию. Пространство выстроено так, чтобы подчеркнуть эклектику, сочетая классические элементы с&nbsp;современными ритмами. Минимализм в графике, воздушные отступы и&nbsp;точечные акценты создают ощущение лёгкости и&nbsp;приватности.
                  <br/><br/>
                  Сайт работает как портрет здания, а не его окружение. Он формирует впечатление через атмосферу, не перегружая информацией. Чистые линии, сбалансированные цвета и&nbsp;продуманная навигация делают взаимодействие естественным, поддерживая чувство уверенности и&nbsp;безупречного вкуса.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="screen">
          <div className="gridBox">
            <div className="gridBox__item gridBox__item_1" style={{backgroundImage: `url('/cases/img/annabels/img1.webp')`}}>
              <img src="/cases/img/annabels/img2.webp" alt="" />
            </div>
            <div className="gridBox__item gridBox__item_2" style={{backgroundImage: `url('/cases/img/annabels/img3.webp')`}}></div>
            <div className="gridBox__item gridBox__item_3" style={{backgroundImage: `url('/cases/img/annabels/img4.webp')`}}>
              <img src="/cases/img/annabels/logo.svg" alt="" className="logo" />
              <div className="title">9 резиденций<br/>Курсовой, 12</div>
            </div>
            <div className="gridBox__item gridBox__item_4" style={{backgroundImage: `url('/cases/img/annabels/img17.webp')`}}></div>
            <div className="gridBox__item gridBox__item_5" style={{backgroundImage: `url('/cases/img/annabels/img5.webp')`}}></div>
            <div className="gridBox__item gridBox__item_6" style={{backgroundImage: `url('/cases/img/annabels/img6.webp')`}}></div>
            <div className="gridBox__item gridBox__item_7" style={{backgroundImage: `url('/cases/img/annabels/img7.webp')`}}></div>
            <div className="gridBox__item gridBox__item_8">
              <div className="gridChild">
                <div className="gridChild__item gridChild__item_1" style={{backgroundImage: `url('/cases/img/annabels/img8.webp')`}}></div>
                <div className="gridChild__item gridChild__item_2" style={{backgroundImage: `url('/cases/img/annabels/img9.webp')`}}></div>
                <div className="gridChild__item gridChild__item_3" style={{backgroundImage: `url('/cases/img/annabels/img10.webp')`}}></div>             
              </div>
            </div>
            <div className="gridBox__item gridBox__item_9">
              <div className="videoBlock">
                <div className="videoBlock__btn" style={{ backgroundImage: `url('/cases/img/annabels/play.svg')` }}></div>
                <video id="video" poster="/cases/img/annabels/poster.webp" loop preload="metadata">
                  <source src="/cases/img/annabels/video.mp4" type="video/mp4"></source>
                </video>
              </div>                
            </div>
            <div className="gridBox__item gridBox__item_10">
              <div className="gridSmall">
                <div className="gridSmall__img" style={{backgroundImage: `url('/cases/img/annabels/img11.webp')`}}>
                  <img src="/cases/img/annabels/img12.webp" alt="" />
                </div>
                <div className="gridSmall__text text">
                  Мобильная версия сайта полностью повторяет функционал основной версии, обеспечивая пользователям доступ ко всем необходимым функциям в любое время и в любом месте. 
                  <br/><br/>
                  Интерфейс оптимизирован для удобства использования на мобильных устройствах, что делает навигацию простой и интуитивной. При этом визуальный дизайн сохраняет эстетическую привлекательность, отражая фирменный стиль проекта и создавая гармоничное восприятие даже на&nbsp;небольших экранах.
                </div>
              </div>
            </div>
            <div className="gridBox__item gridBox__item_11">
              <img src="/cases/img/annabels/img13.webp" alt="" />
              <img src="/cases/img/annabels/img14.webp" alt="" />
              <img src="/cases/img/annabels/img15.webp" alt="" />
              <img src="/cases/img/annabels/img16.webp" alt="" />
            </div>
          </div>
        </div>
			</div>

  

    <CaseFooterNew 
				to={ this.props.next ? this.props.next.url: "/projects/dune/"  }
				title= { this.props.next ? this.props.next.name: `Жилой комплекс “Дюна”`   } 
				img={ this.props.next ? this.props.next.imgCaseBottom: "/cases/img/dune/dune.webp" }
        full={true}
			/>
      <HelmetSite title='Жилой комплекс “Дюна”' />

			<div className="case-info">
				<Link to="/projects/" className="all-title">Все проекты</Link>
				<div className="title">Жилой комплекс “Дюна”</div>
				<div className="tags"><span>фирменный стиль</span><span>сайт</span></div>
			</div>
		</div>
		)
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(annabels)